module.exports = __webpack_public_path__ + "img/smartphone.fdc5edc1.svg";